import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { formValueSelector } from 'redux-form/immutable'
import _ from 'lodash'

import { addGroupMonitoring, initializeGroupMonitoringDialog } from './actions'

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            addGroupMonitoring,
            initializeGroupMonitoringDialog,
        },
        dispatch
    )

const mapStateToProps = (state) => {
    const activeGroupId = state.getIn(['ui', 'groupStack', 'activeGroup'])
    const selector = formValueSelector('groupMonitoringForm')
    const sendingFrequency = selector(state, 'sendingFrequency')

    return {
        sendingFrequency: sendingFrequency || '',
        userEmail: state.getIn(['authorization', 'user', 'email']),
        groupMonitoring: state.getIn(['ui', 'groupMonitoring']),
        activeGroup: state
            .getIn(['ui', 'entityStack', 'groups', 'groups'])
            .find((groupEntity) => _.toString(groupEntity.get('id')) === _.toString(activeGroupId)),
    }
}

export default (InnerComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            activeGroup: IPropTypes.map.isRequired,
            addGroupMonitoring: PropTypes.func.isRequired,
            groupMonitoring: IPropTypes.record.isRequired,
            initializeGroupMonitoringDialog: PropTypes.func.isRequired,
            sendingFrequency: PropTypes.string.isRequired,
            userEmail: PropTypes.string.isRequired,
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
